module.exports = __webpack_public_path__ + "img/fundermax-slider-1.3e4ccd64.jpg";